// All calculator metadata for SEO and listing
// Add new calculators here - they'll auto-appear on landing page

export const calculators = [
  {
    id: 'income-tax',
    slug: 'income-tax',
    name: 'Income Tax Calculator',
    shortName: 'Income Tax',
    description: 'Calculate your income tax for FY 2026-27, compare old vs new tax regime instantly.',
    category: 'tax',
    popular: true,
    new: false,
    image: '/images/calculators/income-tax.png?v=2',
    updatedAt: '2026-02-10',
  },
  {
    id: 'fd-compare',
    slug: 'fd-compare',
    name: 'FD Compare',
    shortName: 'FD Compare',
    description: 'Compare fixed deposit rates across banks and find the best FD.',
    category: 'investment',
    popular: true,
    new: false,
    image: '/images/calculators/fd-compare.png?v=2',
    updatedAt: '2026-02-05',
  },
  {
    id: 'sip',
    slug: 'sip',
    name: 'SIP Calculator',
    shortName: 'SIP',
    description: 'Plan your monthly investments and see how your wealth can grow over time.',
    category: 'investment',
    popular: true,
    new: false,
    image: '/images/calculators/sip.png?v=2',
    updatedAt: '2026-02-01',
  },
  {
    id: 'emi',
    slug: 'emi',
    name: 'EMI Calculator',
    shortName: 'EMI',
    description: 'Calculate quickly your loan EMI for home loan, car loan, or personal loan.',
    category: 'loan',
    popular: true,
    new: false,
    image: '/images/calculators/emi.png?v=2',
    updatedAt: '2026-01-15',
  },
  {
    id: 'ppf',
    slug: 'ppf',
    name: 'PPF Calculator',
    shortName: 'PPF',
    description: 'Calculate your PPF maturity amount and interest earned.',
    category: 'investment',
    popular: false,
    new: false,
    image: '/images/calculators/ppf.png?v=2',
    updatedAt: '2026-01-20',
  },
  {
    id: 'hra',
    slug: 'hra',
    name: 'HRA Calculator',
    shortName: 'HRA',
    description: 'Calculate HRA exemption and save tax on your house rent allowance.',
    category: 'tax',
    popular: false,
    new: false,
    image: '/images/calculators/hra.png?v=2',
    updatedAt: '2026-01-10',
  },
  {
    id: 'gratuity',
    slug: 'gratuity',
    name: 'Gratuity Calculator',
    shortName: 'Gratuity',
    description: 'Calculate your gratuity amount based on years of service.',
    category: 'salary',
    popular: false,
    new: false,
    image: '/images/calculators/gratuity.png?v=2',
    updatedAt: '2026-01-05',
  },
];

// Categories for filtering
export const categories = [
  { id: 'all', name: 'All Calculators' },
  { id: 'tax', name: 'Tax' },
  { id: 'investment', name: 'Investment' },
  { id: 'loan', name: 'Loan' },
  { id: 'salary', name: 'Salary' },
  { id: 'retirement', name: 'Retirement' },
];

// Helper functions
export const getCalculatorBySlug = (slug) => {
  return calculators.find(calc => calc.slug === slug);
};

export const getCalculatorsByCategory = (category) => {
  if (category === 'all') return calculators;
  return calculators.filter(calc => calc.category === category);
};

export const getPopularCalculators = () => {
  return calculators.filter(calc => calc.popular);
};

export const searchCalculators = (query) => {
  const lowerQuery = query.toLowerCase();
  return calculators.filter(calc => 
    calc.name.toLowerCase().includes(lowerQuery) ||
    calc.description.toLowerCase().includes(lowerQuery)
  );
};
